<ng-container *transloco="let t; read: 'blocks.Block::Input::FileUploadInput'">
  <div [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required) && formControl?.invalid && formControl?.touched"
       [ngClass]="{'isFile': blobs?.length > 0}"
       (click)="onClick()"
       class="block-wrapper">

    <label *ngIf="!block.settings.hide_name" [for]="slug" class="name">
    <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
      {{block.localizedName(currentContentLocale, originalContentLocale, true)}}
    </span>
      <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible"></pl-required-indicator>
      <fa-icon *ngIf="blocksConfig.editable && isSecureFileUpload" [icon]="['far', 'shield-check']"
               [attr.data-tooltip-text]="t('security_info')"
               data-tooltip-position="top"
               class="text-success"></fa-icon>
    </label>

    <div [id]="domId + slug + 'description'" class="sr-only">
      <p>
        {{t('introduction.description', {required: block.settings.required ? t('base.required') : ''})}}
      </p>
      <p *ngIf="block.settings.maxFiles == null">{{t('introduction.unlimited_files')}}</p>
      <p *ngIf="block.settings.maxFiles > 1">{{t('introduction.multiple_files', {maxFiles: block?.settings?.maxFiles})}}</p>
      <p *ngIf="block.settings.maxFiles === 1">{{t('introduction.one_file')}}</p>

      <p *ngIf="blobs?.length <= 0">{{t('introduction.open_modal')}}</p>

      <ng-container *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale, true)">
        <p>{{t('help_text')}}</p>
        <p>{{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}.</p>
      </ng-container>

      <p *ngIf="blobs?.length <= 0">{{t('introduction.selected_no_files')}}</p>
      <p *ngIf="blobs?.length === 1">{{t('introduction.selected_one_files')}}</p>
      <p *ngIf="blobs?.length > 1">{{t('introduction.selected_many_files',{number: blobs?.length})}}</p>
    </div>

    <app-file-picker #filePickerComponent
                     [class.ineligible]="ineligible"
                     [disabled]="ineligible || (blocksConfig.editable && blocksConfig.submittable) || (!blocksConfig.editable && !blocksConfig.submittable)"
                     [file]="blobs?.length > 0 ? blobs[0] : undefined"
                     [gizmoDestinationInput]="formControl"
                     [gizmoDestination]="this"
                     [id]="domId + slug"
                     [translation]="blocksConfig.printOptimized ? 'blocks.Block::Input::FileUploadInput.printOptimized' : 'blocks.Block::Input::FileUploadInput'"
                     [style.pointer-events]="blocksConfig.editable ? 'none' : 'auto'"
                     [maxFiles]="block.settings.maxFiles"
                     (fileChange)="onFile($event)"
                     (keydown.enter)="filePickerComponent.clickFileInput()"
                     [attr.aria-labelledby]="domId + slug + 'description'"
                     [mimeTypes]="isSecureFileUpload ? sfusSupportedMimeTypes : []"
                     [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
                     [fontSize]="block.settings.fontSize"
                     tabindex="0"
                     appearance="block"
                     class="d-block">

      <fa-icon *ngIf="!blocksConfig.printOptimized" [fixedWidth]="true" [icon]="['fal', 'cloud-upload']" class="icon" size="lg"></fa-icon>
      <fa-icon *ngIf="!blocksConfig.printOptimized" [fixedWidth]="true" [icon]="['fal', 'cloud-upload']" class="icon-overlay" size="lg"></fa-icon>

      <span *ngIf="!blocksConfig.printOptimized"class="extra-info ml-2">
        {{block.settings.hide_name ? block.settings.name + (block.settings.required ? '*' : ':') : undefined}}
      </span>

      <ng-container *ngTemplateOutlet="fileUploadInputTemplate"></ng-container>

      <div class="hide-when-empty d-flex flex-row align-items-center mt-1">
        <button *ngIf="blobs?.length > 0 && blocksConfig.submittable && block.settings.maxFiles !== 1"
                [attr.disabled]="(ineligible || (block.settings.maxFiles != null && blobs?.length >= block.settings.maxFiles)) ? 'true' : null"
                (click)="filePickerComponent.openFilePicker()"
                type="button"
                class="add-files-button btn btn-link text-primary btn-sm px-0">
          <fa-icon [fixedWidth]="true" [icon]="['far', 'plus']"></fa-icon>
          {{"blocks.Block::Input::FileUploadInput.add_more_files" | transloco}}
        </button>

        <small *ngIf="block.settings.maxFiles != null && block.settings.maxFiles > 1 && blobs?.length >= block.settings.maxFiles"
               class="max-file-count text-muted ml-2">
          {{t('max_file_count')}}
        </small>
      </div>
    </app-file-picker>

    <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
           [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
           class="form-text text-muted"
           aria-hidden="true">
      {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
    </small>
  </div>

  <ng-template #fileUploadInputTemplate>
    <div *ngIf="blobs?.length"
         class="form-control"
         [class.disabled]="ineligible"
         style="height: auto; min-height: auto">

      <p *ngIf="block.settings.hide_name" class="input-name">{{block.settings.name + (block.settings.required ? '*' : ':')}}</p>

      <div *ngFor="let blob of blobs"
           [class.disabled]="ineligible"
           class="file-upload-data d-flex align-items-center justify-content-between">

        <div *ngIf="blob.filename" class="d-flex align-items-center mb-0 mr-2 filename-wrapper">
          <pl-icon class="paperclip" icon="builderAttachmentVertical"></pl-icon>

          <p class="m-0 filename">
            {{blob.filename}}
            <span *ngIf="blob.byte_size > 0" class="size ml-2">{{(blob.byte_size) | fileSize:0 }}</span>
            <span *ngIf="blob.uploadPercentage > 0 && blob.uploadPercentage < 100" class="spinner"> - <app-loading-spinner>
          </app-loading-spinner>{{blob.uploadPercentage | number:'1.0-0'}}%</span>
          </p>
        </div>

        <!-- The download attribute does not work! -->
        <a *ngIf="blob.url"
           [href]="blob.attachmentUrl"
           class="download-button ml-auto flex-shrink-0">
          <pl-icon icon="builderDownload">
          </pl-icon>
          <span class="sr-only">{{t('download_file', {filename: blob.filename})}}</span>
        </a>

        <button *ngIf="blocksConfig.submittable && !ineligible"
                class="btn btn-link p-0 ml-2 remove-button"
                (click)="removeBlob(blob, $event)"
                (keydown.enter)="removeBlob(blob, $event)">
          <fa-icon [fixedWidth]="true"
                   [icon]="['fas', 'trash']"
                   class="trash">
          </fa-icon>
          <span class="sr-only">{{t('delete_file', {filename: blob.filename})}}</span>
        </button>
      </div>
    </div>
  </ng-template>

  <pl-ineligibility-overlay *ngIf="ineligible"></pl-ineligibility-overlay>
</ng-container>
